var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 40,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-180 40.5 40)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 39.25,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    transform: "rotate(-180 39.75 39.25)",
    stroke: "#C7D0DB",
    strokeOpacity: 0.501961,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3588 20.0007C13.3588 19.7734 13.449 19.5555 13.6097 19.3948C13.7704 19.2341 13.9884 19.1438 14.2157 19.1438L24.7131 19.1438L21.034 15.4654C20.873 15.3044 20.7826 15.0861 20.7826 14.8584C20.7826 14.6308 20.873 14.4124 21.034 14.2514C21.195 14.0904 21.4133 14 21.641 14C21.8687 14 22.087 14.0904 22.248 14.2514L27.3896 19.393C27.4694 19.4726 27.5328 19.5672 27.5761 19.6714C27.6193 19.7755 27.6416 19.8872 27.6416 20C27.6416 20.1128 27.6193 20.2245 27.5761 20.3286C27.5328 20.4328 27.4694 20.5274 27.3896 20.607L22.248 25.7486C22.1683 25.8283 22.0736 25.8915 21.9695 25.9347C21.8653 25.9778 21.7537 26 21.641 26C21.5283 26 21.4166 25.9778 21.3125 25.9347C21.2083 25.8915 21.1137 25.8283 21.034 25.7486C20.9543 25.6689 20.8911 25.5742 20.8479 25.4701C20.8048 25.3659 20.7826 25.2543 20.7826 25.1416C20.7826 25.0289 20.8048 24.9172 20.8479 24.8131C20.8911 24.7089 20.9543 24.6143 21.034 24.5346L24.7131 20.8576L14.2157 20.8576C13.9884 20.8576 13.7704 20.7674 13.6097 20.6067C13.449 20.446 13.3588 20.228 13.3588 20.0007Z",
    fill: "#0516C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.46c9a6694dd94a9925d183bedfffd14c.svg";
export { ForwardRef as ReactComponent };